import { rightLanguage } from "@/sharedTypes/helpers";
import { Fzf } from "fzf";

export default class SamplesFinder {
  fzf: any = null;
  samples: any[] = [];

  constructor(samples: any[]) {
    this.samples = samples;

    // Create a search that includes both title and category
    this.fzf = new Fzf(samples, {
      selector: sample => {
        return `${rightLanguage(sample.category)} ${rightLanguage(sample.metadata.title)}`;
      },
      casing: 'case-insensitive',
    });
  }
  // it still doesnt work for Этюд 1(any number) but works for words
search(query: string) {
  const queryWords = query.trim().toLowerCase().split(/\s+/);

  return this.samples.filter(sample => {
    const text = `${rightLanguage(sample.category)} ${rightLanguage(sample.metadata.title)}`.toLowerCase();
    const sampleWords = text.split(/\s+/);

    const filteredWords = queryWords.every(qw =>
      sampleWords.some(sw => sw.startsWith(qw))
    );
    // Every query word must match the start of some sample word
    return filteredWords;
  });
}
}
